<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="replacementBillVo.pkid > 0 ? '编辑' : '新建'"
      class="replacementBill-edit"
      width="1400px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="replacementBillVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="系统编号">
            <el-input v-model="replacementBillVo.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="replacementBillVo.creatTime"
                style="width: 190px"
                type="datetime"
                disabled
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记人">
            <el-input v-model="replacementBillVo.creatorName" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="前续订单" prop="sourceOrder" :rules="[{ required: replacementBillVo.type === 0, message: '请选择前续订单', trigger: ['blur', 'change'] }]">
            <el-input v-model="replacementBillVo.sourceOrder" readonly placeholder="请选择前续订单">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.salesOrderSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="replacementBillVo.customerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务员" prop="salesPersonName">
            <!-- 根据条件动态显示业务员选择方式 -->
            <el-select
                v-if="useSalesDropdown"
                v-model="replacementBillVo.salesPersonId"
                placeholder="请选择业务员"
                @change="handleSaleChange">
              <el-option
                  v-for="item in salesPersonList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
            </el-select>
            <el-input
                v-else
                v-model="replacementBillVo.salesPersonName"
                placeholder="请选择"
                readonly>
              <el-button slot="append" icon="el-icon-search" @click="handleOpenUser(1)"/>
            </el-input>
            <user-select ref="selectSupplierManage" @select="onSelectSalesPerson"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商务" prop="businessName">
            <!-- 根据条件动态显示商务选择方式 -->
            <el-select
                v-if="useBusinessDropdown"
                v-model="replacementBillVo.businessId"
                placeholder="请选择商务"
                @change="handleBusinessChange">
              <el-option
                  v-for="item in businessList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
            </el-select>
            <el-input
                v-else
                v-model="replacementBillVo.businessName"
                placeholder="请选择"
                readonly>
              <el-button slot="append" icon="el-icon-search" @click="handleOpenUser(2)"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退货类型" prop="type">
            <el-select v-model="replacementBillVo.type">
              <el-option label="退货" :value="0"/>
              <el-option label="换货" :value="1"/>
              <el-option label="寄售退回" :value="2"/>
              <el-option label="借出退回" :value="3"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="退货原因" prop="orderReturnReason">
            <el-select v-model="replacementBillVo.orderReturnReason">
              <el-option label="质量原因" :value="0"/>
              <el-option label="客户原因" :value="1"/>
              <el-option label="服务机原因" :value="2"/>
              <el-option label="技术升级" :value="3"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退货事由" prop="returnReason">
            <el-select v-model="replacementBillVo.returnReason">
              <el-option label="样机退货" :value="0"/>
              <el-option label="订单退货" :value="1"/>
              <el-option label="服务机退货" :value="2"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否安装" prop="installed">
            <el-select v-model="replacementBillVo.installed">
              <el-option label="是" :value="0"/>
              <el-option label="否" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="replacementBillVo.returnReason!==2">
        <el-col :span="8">
          <el-form-item label="发出时间">
            <el-date-picker
                v-model="replacementBillVo.sendDate"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="返回快递单号" prop="customerDeliverSn">
            <el-input v-model="replacementBillVo.customerDeliverSn"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="事由" prop="reason">
            <el-input v-model="replacementBillVo.reason" type="textarea"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="已使用时间（月）" prop="usedDate">
            <el-select v-model="replacementBillVo.usedDate">
              <el-option label="拆箱未使用" :value="0"/>
              <el-option label="1个月内" :value="1"/>
              <el-option label="1-3个月" :value="2"/>
              <el-option label="6个月内" :value="3"/>
              <el-option label="6个月及以上" :value="4"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费用承担" prop="bearCost">
            <el-select v-model="replacementBillVo.bearCost">
              <el-option label="客户承担" :value="0"/>
              <el-option label="公司承担" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="原因分析" prop="reasonAnalise">
            <el-select v-model="replacementBillVo.reasonAnalise">
              <el-option label="发货错" :value="0"/>
              <el-option label="商务制单出错" :value="1"/>
              <el-option label="客户需求变更" :value="2"/>
              <el-option label="品质异常" :value="3"/>
              <el-option label="选型异常" :value="4"/>
              <el-option label="其他" :value="5"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="处理意见" prop="handleSuggestion">
            <el-select v-model="replacementBillVo.handleSuggestion">
              <el-option label="直接办退" :value="0"/>
              <el-option label="换货未处理" :value="1"/>
              <el-option label="换货已处理" :value="2"/>
              <el-option label="其他" :value="3"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否开票" prop="ticketed">
            <el-select v-model="replacementBillVo.ticketed">
              <el-option label="是" :value="0"/>
              <el-option label="否" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="一次性退货是否达到一万元" prop="overAmount">
            <el-select v-model="replacementBillVo.overAmount">
              <el-option label="是" :value="0"/>
              <el-option label="否" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="到货信息是否一致" prop="consistent">
            <el-select v-model="replacementBillVo.consistent">
              <el-option label="是" :value="0"/>
              <el-option label="否" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="返厂流程单号" prop="returnFactorySn">
            <el-input v-model="replacementBillVo.returnFactorySn"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="异常信息" prop="exceptReason">
            <el-input v-model="replacementBillVo.exceptReason" type="textarea"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vm-separate">
        <el-form-item label="订购原因" prop="orderReason">
          <el-select v-model="replacementBillVo.orderReason" placeholder="请选择订购原因">
            <el-option v-for="item in orderReasonList" :key="item.no" :value="item.no" :label="item.name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="质量分析结果">
          <el-input v-model="replacementBillVo.qualityAnalise" disabled type="textarea"/>
        </el-form-item>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          产品信息-发出
        </div>
        <el-button
            type="primary"
            style="margin-bottom: 10px"
            @click="addDetails">
          添加物料
        </el-button>
        <el-table
            :data="replacementBillVo.details"
            border>
          <el-table-column prop="materialNo" width="160" align="center" label="物料号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.materialNo" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="productModel" width="160" align="center" label="产品型号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productModel" placeholder="请输入">
                <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="sn" width="160" align="center" label="序列号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.sn" type="textarea" autosize placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="productName" width="160" align="center" label="产品名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" placeholder="请输入" autosize type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column prop="quality" width="100" align="center" label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quality" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="unit" width="100" align="center" label="单位">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="amount" width="100" align="center" label="金额">
            <template slot-scope="scope">
              <el-input v-model="scope.row.amount" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="memo" width="120" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.memo" placeholder="请输入" autosize type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column prop="delivered" width="100" align="center" label="是否已发货">
            <template slot-scope="scope">
              <el-select v-model="scope.row.delivered" clearable size="mini" placeholder="请选择">
                <el-option label="是" :value="0"/>
                <el-option label="否" :value="1"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="deliverSn" width="120" align="center" label="发运单号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliverSn" type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="" width="220" align="center" label="出库时间">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.deliverDate"
                  style="width: 190px"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              fixed="right"
              width="100px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <material-c-s-select ref="selectMaterial" @select="getDetails"/>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          产品信息-退回
        </div>
        <el-button
            type="primary"
            style="margin-bottom: 10px"
            @click="addReturnMaterialDetails">
          添加物料
        </el-button>
        <el-table
            :data="replacementBillVo.returnMaterialDetails"
            border>
          <el-table-column prop="materialNo" width="160" align="center" label="物料号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.materialNo" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="productModel" width="160" align="center" label="产品型号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productModel" placeholder="请输入">
                <el-button slot="append" icon="el-icon-search" @click="openReturnMaterialSelectDialog(scope.$index)"/>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="sn" width="160" align="center" label="序列号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.sn" type="textarea" autosize placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="productName" width="160" align="center" label="产品名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" placeholder="请输入" autosize type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column prop="quality" width="100" align="center" label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quality" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="unit" width="100" align="center" label="单位">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="amount" width="100" align="center" label="金额">
            <template slot-scope="scope">
              <el-input v-model="scope.row.amount" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="memo" width="120" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.memo" placeholder="请输入" autosize type="textarea"/>
            </template>
          </el-table-column>
          <el-table-column prop="delivered" width="100" align="center" label="是否已发货">
            <template slot-scope="scope">
              <el-select v-model="scope.row.delivered" clearable size="mini" placeholder="请选择">
                <el-option label="是" :value="0"/>
                <el-option label="否" :value="1"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="deliverSn" width="120" align="center" label="发运单号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliverSn" type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="" width="220" align="center" label="出库时间">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.deliverDate"
                  style="width: 190px"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              fixed="right"
              width="100px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDeleteByReturn(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <material-c-s-select ref="selectReturnMaterial" @select="getReturnMaterialDetails"/>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          订单附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="replacementBillVo.attachments"
            ref="payData1"
            :data="replacementBillVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              width="60"
              class-name="vm-table_operate"
              fixed="right">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button
          :loading="submitLoading"
          type="primary"
          @click="handleSubmit">确定</el-button>
    </span>
    <sales-order-select ref="salesOrderSelect" @select="selectOrder"/>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import UploadFile from "@/components/UploadFile";
  import MaterialCSSelect from "@/views/AfterSaleManage/ReplacementBill/MaterialCSSelect";
  import SalesOrderSelect from "@/views/SalesManage/SalesOrder/SalesOrderSelect";

  export default {
    name: "ReplacementBillEdit",
    components: {SalesOrderSelect, MaterialCSSelect, UploadFile, CustomerSelect,UserSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        orderReasonList: [],
        selectUserType: 1,
        // 业务员和商务列表
        salesPersonList: [],
        businessList: [],
        // 是否使用下拉列表显示业务员和商务
        useSalesDropdown: false,
        useBusinessDropdown: false,
        replacementBillVo: {
          pkid: "",
          billNo: "",
          orderReason: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: loginUtil.getName(),
          customerId: "",
          customerName: "",
          orderReturnReason: "",
          orderReturnReasonName: "",
          returnReason: "",
          typeName: "",
          type: "",
          status: 0,
          returnReasonName: "",
          installed: "",
          bearCost: "",
          sendDate: "",
          deliverSn: "",
          customerDeliverSn: "",
          salesPersonId: "",
          salesPersonName: "",
          businessName: "",
          businessId: "",
          reason: "",
          usedDate: "",
          bearCostPart: "",
          reasonAnalise: "",
          handleSuggestion: "",
          consistent: "",
          returnFactorySn: "",
          exceptReason: "",
          ticketed: "",
          sourceOrder: "",
          pOSEX_E: "",
          overAmount: "",
          attachments: [],
          details: [],
          returnMaterialDetails: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
          orderReturnReason: {required: true, message: "退货原因不能为空", trigger: "change"},
          type: {required: true, message: "退货类型不能为空", trigger: "change"},
          returnReason: {required: true, message: "退货事由不能为空", trigger: "change"},
          installed: {required: true, message: "是否安装不能为空", trigger: "change"},
          customerDeliverSn: {required: true, message: "返回快递单号不能为空", trigger: "blur"},
          reason: {required: true, message: "事由不能为空", trigger: "blur"},
          usedDate: {required: true, message: "已使用时间不能为空", trigger: "change"},
          bearCost: {required: true, message: "费用承担不能为空", trigger: "change"},
          reasonAnalise: {required: true, message: "原因分析不能为空", trigger: "change"},
          handleSuggestion: {required: true, message: "处理意见不能为空", trigger: "change"},
          ticketed: {required: true, message: "是否开票不能为空", trigger: "change"},
          overAmount: {required: true, message: "一次性退货是否达到一万元不能为空", trigger: "change"},
          consistent: {required: true, message: "到货信息是否一致不能为空", trigger: "change"},
          returnFactorySn: {required: true, message: "返厂流程单号不能为空", trigger: "blur"},
          exceptReason: {required: true, message: "异常信息不能为空", trigger: "blur"},
          orderReason: {required: true, message: "订购原因不能为空", trigger: "change"},
          salesPersonId: {required: true, message: "业务员不能为空", trigger: "change"},
          salesPersonName: {required: true, message: "业务员不能为空", trigger: "blur"},
          businessId: {required: true, message: "商务不能为空", trigger: "change"},
          businessName: {required: true, message: "商务不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.replacementBillVo.pkid = row.pkid;
          if (this.replacementBillVo.pkid > 0) {
            this.getData();
          }
        }
        this.getorderReason();
      },
      getData() {
        this.$http
          .get("basic", `replacementBills/${this.replacementBillVo.pkid}`)
          .then(resp => {
            this.replacementBillVo = resp.data;
            this.replacementBillVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          });
      },
      handleOpenUser(type) {
        this.selectUserType = type;
        this.$refs.selectSupplierManage.open();
      },
      onSelectSalesPerson(row) {
        if (this.selectUserType == 1) {
          this.replacementBillVo.salesPersonId = row.systemUserID;
          this.replacementBillVo.salesPersonName = row.employeeName;
        } else {
          this.replacementBillVo.businessId = row.systemUserID;
          this.replacementBillVo.businessName = row.employeeName;
        }
      },
      selectOrder(row) {
        this.$http
          .get("basic", `sapSalesOrders/getSourceOrder/${row.pkId}`)
          .then((res) => {
            console.log(res);
            if (res.success) {
              this.replacementBillVo.sourceOrder = res.data.billNo;
              this.replacementBillVo.property = res.data.property;
              this.replacementBillVo.customerId = res.data.customerId;
              this.replacementBillVo.customerName = res.data.customerName;
              if (res.data.orderReason) {
                this.replacementBillVo.orderReason = res.data.orderReason;
              }
              res.data.materialVOS.forEach(item=>{
                if (item.POSEX_E!=null) {
                  this.replacementBillVo.pOSEX_E = item.POSEX_E;
                }else {
                  this.replacementBillVo.pOSEX_E = "000010";
                }
                this.replacementBillVo.details.push({
                  pkid: 0,
                  masterId: 0,
                  productName: item.materialName,
                  productModel: item.specification,
                  materialNo: item.materialNo,
                  unit: item.unit,
                  memo: "",
                  deliverDate: "",
                  deliverSn: "",
                  quality: item.remainQuantity,
                  POSEX_E: item.POSEX_E,
                });
                this.replacementBillVo.returnMaterialDetails.push({
                  pkid: 0,
                  masterId: 0,
                  productName: item.materialName,
                  productModel: item.specification,
                  materialNo: item.materialNo,
                  unit: item.unit,
                  deliverDate: "",
                  memo: "",
                  deliverSn: "",
                  quality: item.remainQuantity,
                  POSEX_E: item.POSEX_E,
                });
              });

            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },
      getDetails(row, index) {
        console.log(row);
        // this.replacementBillVo.details[index].materialId = row.id;
        this.replacementBillVo.details[index].productName = row.name;
        this.replacementBillVo.details[index].materialNo = row.no;
        this.replacementBillVo.details[index].productModel = row.zmyxh;
      },
      getorderReason() {
        this.$http.get("basic", "sapSalesOrders/getorderReason").then((res) => {
          if (res.success) {
            this.orderReasonList = res.data;
          }
        });
      },
      getReturnMaterialDetails(row, index) {
        console.log(row);
        this.replacementBillVo.returnMaterialDetails[index].productName = row.name;
        this.replacementBillVo.returnMaterialDetails[index].materialNo = row.no;
        this.replacementBillVo.returnMaterialDetails[index].productModel = row.zmyxh;
      },
      fileDelete(index) {
        this.replacementBillVo.attachments.splice(index, 1);
      },
      addDetails() {
        this.replacementBillVo.details.push({
          pkid: 0,
          masterId: 0,
          materialNo: "",
          productName: "",
          productModel: "",
          unit: "",
          memo: "",
          deliverDate: "",
          deliverSn: "",
          quality: 1,
          POSEX_E: this.replacementBillVo.pOSEX_E,
        });
        this.replacementBillVo.returnMaterialDetails.push({
          pkid: 0,
          masterId: 0,
          productName: "",
          productModel: "",
          unit: "",
          deliverDate: "",
          memo: "",
          deliverSn: "",
          quality: 1,
          POSEX_E: this.replacementBillVo.pOSEX_E,
        });
      },
      addReturnMaterialDetails() {
        this.replacementBillVo.returnMaterialDetails.push({
          pkid: 0,
          masterId: 0,
          materialNo: 0,
          productName: "",
          productModel: "",
          unit: "",
          deliverDate: "",
          memo: "",
          deliverSn: "",
          quality: 1,
        });
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      openReturnMaterialSelectDialog(index) {
        this.$refs.selectReturnMaterial.open(index);
      },
      oneDelete(index) {
        this.replacementBillVo.details.splice(index, 1);
      },
      oneDeleteByReturn(index) {
        this.replacementBillVo.returnMaterialDetails.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.replacementBillVo.attachments.push(params);
        }
      },
      // 根据客户ID获取业务员和商务列表
      getSalesAndBusinessList(customerId) {
        // 调用API获取客户员工信息
        this.$http
          .get("basic", `customers/getCustomerEmployeeList/${customerId}`)
          .then((res) => {
            if (res.success && Array.isArray(res.data)) {
              // 清空列表
              this.salesPersonList = [];
              this.businessList = [];
              
              // 根据belongType字段区分业务员和商务
              // 10: 业务员, 20: 商务
              res.data.forEach(item => {
                if (item.belongType === 10) {
                  // 业务员
                  this.salesPersonList.push({
                    id: item.systemUserID,
                    name: item.employeeName,
                  });
                } else if (item.belongType === 20) {
                  // 商务
                  this.businessList.push({
                    id: item.systemUserID,
                    name: item.employeeName,
                  });
                }
              });
              
              // 如果列表不为空，使用下拉列表显示并默认选中第一个
              if (this.salesPersonList.length > 0) {
                this.useSalesDropdown = true;
                this.replacementBillVo.salesPersonId = this.salesPersonList[0].id;
                this.replacementBillVo.salesPersonName = this.salesPersonList[0].name;
              } else {
                this.useSalesDropdown = false;
              }
              
              if (this.businessList.length > 0) {
                this.useBusinessDropdown = true;
                this.replacementBillVo.businessId = this.businessList[0].id;
                this.replacementBillVo.businessName = this.businessList[0].name;
              } else {
                this.useBusinessDropdown = false;
              }
            } else {
              // 数据为空，保持原有的选择功能
              this.useSalesDropdown = false;
              this.useBusinessDropdown = false;
            }
          })
          .catch(() => {
            // 请求失败，保持原有的选择功能
            this.useSalesDropdown = false;
            this.useBusinessDropdown = false;
          });
      },
      handleSaleChange(value) {
        const selected = this.salesPersonList.find(item => item.id === value);
        if (selected) {
          this.replacementBillVo.salesPersonName = selected.name;
        }
      },
      handleBusinessChange(value) {
        const selected = this.businessList.find(item => item.id === value);
        if (selected) {
          this.replacementBillVo.businessName = selected.name;
        }
      },
      selectCustomer(row) {
        // 切换客户时，清空历史的业务员和商务信息
        this.replacementBillVo.salesPersonId = null;
        this.replacementBillVo.salesPersonName = "";
        this.replacementBillVo.businessId = null;
        this.replacementBillVo.businessName = "";
        
        // 重置下拉列表状态
        this.useSalesDropdown = false;
        this.useBusinessDropdown = false;
        this.salesPersonList = [];
        this.businessList = [];
        
        // 设置新选择的客户信息
        this.replacementBillVo.customerName = row.customerName;
        this.replacementBillVo.customerId = row.customerID;
        
        // 根据客户ID获取新的业务员和商务列表
        if (row.customerID) {
          this.getSalesAndBusinessList(row.customerID);
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.replacementBillVo.pkid > 0) {
              this.$http
                .put("basic", "replacementBills", this.replacementBillVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "replacementBills", this.replacementBillVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog{
    top: 10% !important;
    left: 0 !important;
  }
</style>